<template>
  <b-row
    align-content="start"
    align-h="center"
    align-v="center"
    class="mx-0 border rounded py-3 bg-white advance_filter_box"
  >
    <b-col cols="12" md="12" class="mb-3">
      <b-button block variant="outline-danger" @click="closeAdvance">
        <mdicon name="close" size="20" class="mr-2" />
        <span v-text="$lang.close_filter_box" />
      </b-button>
    </b-col>
    <b-col
      cols="12"
      md="12"
      v-for="(header, index) in headers"
      :key="index"
      :class="{ last_child: index >= headers.length - 1 }"
    >
      <AdvanceFilterCheckboxSingleSelect
        v-if="header.type === 'checkbox_singleselect'"
        ref="filterItem"
        :header="header"
        :open="!!header.open"
        :value="header.selected"
        @selected="selected"
      />
      <AdvanceFilterCheckboxMultiselect
        v-if="header.type === 'checkbox_multiselect'"
        :value="header.selected"
        ref="filterItem"
        :header="header"
        :open="!!header.open"
        @selected="selected"
      />
      <AdvanceFilterText
        v-if="header.type === 'text'"
        ref="filterItem"
        :value="header.selected"
        :header="header"
        :open="!!header.open"
        @selected="selected"
      />
      <DateTime
        v-if="
          header.advanced &&
          ['date', 'datetime', 'time', 'year', 'yearmonth', 'month'].includes(
            header.type
          )
        "
        ref="filterItem"
        :value="header.selected"
        :header="header"
        :open="!!header.open"
        @dateSelected="dateSelected"
      />
      <AdvanceFilterNumber
        ref="filterItem"
        v-if="header.advanced && header.type === 'number'"
        :value="header.selected"
        :header="header"
        :open="!!header.open"
        @numberSelected="dateSelected"
      />
    </b-col>
  </b-row>
</template>
<script>
import AdvanceFilterCheckboxSingleSelect from "../base/advanceFilterCheckboxSingleSelect";
import AdvanceFilterCheckboxMultiselect from "../base/advanceFilterCheckboxMultiselect";
import AdvanceFilterText from "../base/advanceFilterText";
import AdvanceFilterNumber from "../base/advanceFilterNumber";
import DateTime from "../base/dateTime";
import { pathOr } from "ramda";

export default {
  components: {
    AdvanceFilterCheckboxSingleSelect,
    AdvanceFilterCheckboxMultiselect,
    AdvanceFilterText,
    AdvanceFilterNumber,
    DateTime,
  },
  props: {
    headers: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showBox: false,
      params: {},
    };
  },
  methods: {
    pathOr,
    closeAdvance() {
      this.$emit("closeAdvanceFilter");
    },
    // not use
    /* removeAllFilters() {
      this.$refs.filterItem &&
        this.$refs.filterItem.map((item) => item.deleteValue());
    }, */
    dateSelected(key, type, value_from, value_to) {
      this.$emit("getFilterDate", key, type, value_from, value_to);
    },
    selected(value, key) {
      this.$emit("getFilterItems", value, key);
    },
  },
};
</script>

<style lang="scss">
.advance_filter_box {
  position: absolute;
  left: -6px;
  top: 46px;
  width: 300px;
  height: 70vh;
  z-index: 99;
  overflow-x: hidden;
  overflow-y: auto;
  .last_child {
    .my {
      padding-bottom: 100px !important;
    }
    .not-expanded {
      padding-bottom: 0px !important;
    }
  }
}
.close_advance_filter {
  background: #cf2f2f;
  border-radius: 5px;
  height: 35px;
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -ms-flex-line-pack: center;
  align-content: center;
  font-size: 27px;
  color: white;
  margin-bottom: 10px;
  cursor: pointer;
}
.my {
  margin-bottom: 10px;
  width: 100%;
  border: 1px solid #f0f3f5;
  border-radius: 4px;

  &-header {
    cursor: pointer;
    position: relative;

    .icon {
      transform: rotate(180deg);
      transition: transform 150ms ease-out;
    }
  }

  .my-content {
    transition: all 150ms ease;
    max-height: 300px;
    overflow-x: hidden;
    overflow-y: auto;
  }
}

.my {
  background-color: #fff;
  // box-shadow: 0 2px 3px lightgray;
  color: #4a4a4a;
  width: 100%;
}

.not-expanded {
  .my-header {
    .icon {
      transform: rotate(0deg);
    }

    max-height: 330px;
    overflow: auto;
  }

  .my-content {
    transform: scaleY(0);
    transform-origin: top;
    opacity: 0;
    height: 0;
    padding: 0;
  }
}

.my-header {
  -webkit-box-align: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  // box-shadow: 0 1px 2px lightgray;
  background-color: #f0f3f5;
  border-radius: 4px;
  display: flex;
  min-height: 40px;
}
.my-header-title {
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  color: #4a4a4a;
  display: flex;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  font-weight: 700;
  font-size: 12px;
  align-items: center;
  margin: 0;
}
.my-header-icon {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  cursor: pointer;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  width: 40px;
  align-items: center;
  margin: 0;
}
.my-header-icon-remove {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  cursor: pointer;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  width: 20px;
  height: 100%;
  align-items: center;
  margin: 0;
}
.filter-trash {
  background: #f86c6b;
  color: white;
  border-radius: 0 5px 5px 0;
  height: 100%;
  position: absolute;
}
.information-icon {
  animation: pulse_primary 2s infinite;
  border-radius: 50%;
}
</style>
